var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sk-close",class:{ dark: _vm.$store.getters.darkmode },on:{"click":_vm.handleClick}},[_c('i',{staticClass:"ti-cross-circle-filled"})])}
var staticRenderFns = []

export { render, staticRenderFns }